import React from "react";
import { Tooltip, Typography } from "@mui/material";
import Markdown from "@/components/Markdown";
import InfoIcon from "@mui/icons-material/Info";
import styles from "./TitleContribute.module.scss";
// import InfoIcon from "@fortawesome/fontawesome-free/svgs/solid/info-circle.svg";

const TitleContribute = ({ title, tooltip }) => (
  <Typography
    variant="h4"
    className={styles.contributePanelTitle}
    component="div"
  >
    <Markdown>{title}</Markdown>
    {tooltip && (
      <Tooltip title={tooltip}>
        <InfoIcon sx={{ color: "#999 !important", fontSize: "16px" }} />
      </Tooltip>
    )}
  </Typography>
);

export default TitleContribute;
